export default function ErrorTestPage() {
  throw new Error("this page can't be used");
}
